export default {

    title: 'Vorgänge',
    freetext: 'Freitext',
    process_number: 'Vorgangsnummer',
    sl_number: 'SL-Nummer',
    year: 'Jahr',
    status: 'Status', // old filter name, might be stored in someone's localstorage
    statusKey: 'Status',
    id: 'ID',
    event: 'Veranstaltung',
    eventEndDate: 'Veranstaltungsende',
    organisation: 'Organisation',
    customFilterTransferAgreement: 'Weitergabevertrag',
    fundingProgram: 'Förderprogramm',
    funding_program: 'Förderprogramm',
    period: 'Von - Bis',
    formProcesses: 'Formulare',
    subsidy_due: 'Zuschuss',
    started_at: 'Gestartet am',
    customFilterHasOpenPayment: 'Offene Zahlungen',
    association: 'Verband',
    symbols: 'Infos mobil', // header for mobile column

    qf_ownOnly: 'Nur eigene Vorgänge'
}